import React, { useEffect, useState } from 'react';
import Marquees from "react-fast-marquee";
import { useDispatch, useSelector } from 'react-redux';
import { fetchAlert } from '../Redux/Dashboard/Components/AlertAction';
import Cookies from 'js-cookie';
import { useFeatureFlags } from '../FeatureFlags/FeatureFlagsContext';
import { FEATURE_FLAGS } from '../FeatureFlags/featureFlagConstants';

const Marquee = React.memo(() => {
  const dispatch = useDispatch();
  const { isFeatureEnabled } = useFeatureFlags();
  const enableAlertManagement = isFeatureEnabled(FEATURE_FLAGS.EnableAlertManagement);
  const { message } = useSelector(state => state.alert);
  const [isFetching, setIsFetching] = useState(false);

  useEffect(() => {
    if (!enableAlertManagement) {
      return undefined;
    }
    const fetchData = async () => {
      try {
        setIsFetching(true);
        await dispatch(fetchAlert());
        console.log("Alert fetched");
      } catch (error) {
        console.error("Error fetching alert:", error);
      } finally {
        setIsFetching(false);
      }
    };

    const checkTokenAndFetch = async () => {
      const accessToken = Cookies.get('accessToken'); // Get token within the effect
      if (accessToken) {
        const tokenExpiry = parseInt(Cookies.get('accessTokenExpiry'), 10);
        const now = Date.now();

        if (tokenExpiry && now < tokenExpiry) {
          await fetchData();
        } else {
          console.log("Token expired or invalid, not fetching alerts");
        }
      }
    };

    // Call fetch only once during initial mount
    console.log("Initial fetch attempt");
    checkTokenAndFetch();

    // Set up interval for subsequent fetches every 5 minutes
    const intervalId = setInterval(() => {
      console.log("Interval triggered");
      checkTokenAndFetch();
    }, 300000);

    // Cleanup interval on unmount
    return () => {
      console.log("Clearing interval");
      clearInterval(intervalId);
    };
  }, [dispatch, enableAlertManagement]); // Only include `dispatch` to ensure the effect runs only once on mount

  if (!enableAlertManagement || isFetching || !message) {
    return null; 
  }

  return (
    <div className='marq-div'>
      <Marquees>
        {message} {/* Fallback message */}
      </Marquees>
    </div>
  );
});

export default Marquee;
